import React, { useMemo, useState, useCallback } from 'react'
import { BaseDrawer } from '@/components/drawer/base-drawer'
import { layerManage, showLayer } from '@/utils/layer'
import { Column, Row, Expaned } from '@/components/layout/layout'
import FormTitle from '../../../../components/form/form-title/form-title'
import { getBEMCls } from '@/utils/classname'
import dayjs from 'dayjs'
import classnames from 'classnames'

import './edit-purchase.scss'
import { DatePicker } from 'antd'
import Table, { ColumnsType } from 'antd/lib/table'
import { Goods, Unit } from '@/model/types/goods'
import { ISupplier } from '@/model/types/supllier'
import Iconfont from '@/components/iconfont/iconfont'
import Big from 'big.js'
import { useRequest, useMount, usePersistFn } from 'ahooks'
import { $post } from '@/api'
import SelectGoods, { useSelectGoods } from '../../../../components/select-goods/select-goods'
import { goodsModel } from '../../../../goods-storage/goods-library/modules/edit-goods/modules/model'
import { setObj, deepClone, uniqBy, INPUT_PRICE_LIMIT_REGEXP } from '@/utils'
import RemarkPopover from '../../../../components/remark-popover/remark-popover'
import LayoutInput from '../../../../components/form/layout-input/layout-input'
import Button from '@/components/button/button'
import Supplier from '../../../../goods-storage/goods-library/modules/edit-goods/modules/supplier/supplier'
import PurchaseUnitPopover from './puchase-unit-popover'
import $msg from '@/utils/message'
import { purchaseOrderStore } from '../../model'
import { Modal } from '@/components/dialog/modal'
import useSetDataTogether from '@/utils/hooks/useSetDataTogether'
import moment from 'moment'
import EditPruchaseConfirm from './edit-purchase-confirm'

export interface IPurchaseList {
    amount: number
    goods: Goods
    order_id?: number
    price: number
    purchase_unit: Unit
    stock_unit: Unit
    purchase_unit_positive: boolean
    purchase_unit_ratio: number
    remarks: string
    subtotal: number
    supplier: ISupplier | null
}

interface EditPurchaseProps {
    orderId?: number
}

const EditPurchase: React.FC<EditPurchaseProps> = props => {
    const cls = (...arg: string[]) => getBEMCls('edit-purchase', ...arg)
    const formatDate = useMemo(() => (date: dayjs.Dayjs) => date.format('MM-DD'), [])

    const [day, setDay] = useState<number>(0)

    const [eta, setEta] = useState<string>(() => dayjs().format('YYYY-MM-DD'))
    const [purchaseList, setPurchaseList] = useState<IPurchaseList[]>([])

    const { reduceGoods: reduceSelectGood, initGoods: initSelectGoods } = useSelectGoods()

    const setAllData = useSetDataTogether()

    // 请求草稿信息
    const raftReq = useRequest(
        () =>
            $post({
                url: '/warehouse/getpurchaseorderdetail',
                params: {
                    order_id: props.orderId,
                },
            }),
        {
            manual: true,
            onSuccess: res => {
                setAllData(() => {
                    if (dayjs().isAfter(`${res.order_info.eta} 23:59`)) {
                        setDay(-1)
                    } else {
                        const dayaList = [0, 1, 2].map(i => dayjs().add(i, 'day').format('YYYY-MM-DD'))
                        const dayIndex = dayaList.indexOf(res.order_info.eta)
                        if (dayIndex !== -1) {
                            setDay(dayIndex)
                        } else {
                            setDay(3)
                        }
                    }

                    setEta(res.order_info.eta)
                    setPurchaseList(
                        res.order_info.order_goods_list.map((s: any) => ({
                            ...s,
                            stock_unit: s.goods.stock_unit,
                            purchase_unit_positive: true,
                        })),
                    )
                })

                initSelectGoods(res.order_info.order_goods_list.map((i: any) => i.goods))
            },
        },
    )

    useMount(() => {
        goodsModel.init()
        props.orderId && raftReq.run()
    })

    const btnDisabled = useMemo(
        () => !purchaseList.length || purchaseList.some(l => !Number(l.subtotal) || !Number(l.amount)),
        [purchaseList],
    )

    const handleSupplier = usePersistFn((id: number, index: number) => {
        showLayer(
            <Supplier
                selectSuplierIds={[id]}
                selectType="radio"
                onSelected={item => {
                    setPurchaseList(deepClone(setObj(purchaseList, `[${index}].supplier`, item[0])))
                }}
            ></Supplier>,
        )
    })

    const columns: ColumnsType<IPurchaseList> = [
        {
            title: '#',
            key: 'index',
            width: 50,
            render: (value, record, index) => index + 1,
        },
        {
            title: '商品名',
            key: 'name',
            ellipsis: true,
            dataIndex: 'goods',
            render: val => val.name,
        },
        {
            title: '上架',
            width: 70,
            dataIndex: 'goods',
            render: val => (
                <Row>
                    {val.status === 0 || val.on_mall ? (
                        <React.Fragment>
                            <span className={cls('icon')}>
                                {val.on_mall && <Iconfont name="icon2shangjiaweishangcheng" size={20} />}
                            </span>
                            <span>
                                {val.status === 0 && (
                                    <Iconfont
                                        name="icon2shangjiashouyintai"
                                        size={20}
                                        style={{
                                            marginLeft: '8px',
                                        }}
                                    />
                                )}
                            </span>
                        </React.Fragment>
                    ) : (
                        <span>
                            <Iconfont name="iconweishangjia1" size={35}></Iconfont>
                        </span>
                    )}
                </Row>
            ),
        },
        {
            title: '供货商',
            key: 'supplier',
            dataIndex: 'supplier',
            render: (val, record, index) => (
                <Row data-cursor-pointer data-align-items-center onClick={() => handleSupplier(val.id, index)}>
                    {val.name}
                    <Iconfont data-margin-left-4 name="icon6youjiantou-20" size={16} />
                </Row>
            ),
        },
        {
            title: '采购单价',
            key: 'price',
            dataIndex: 'price',
            width: 150,
            render: (val, record, index) => (
                <Row data-align-items-center>
                    <LayoutInput
                        value={val}
                        valueRegExp={INPUT_PRICE_LIMIT_REGEXP}
                        onBlur={e => {
                            let root = purchaseList
                            if (record.amount) {
                                root = setObj(
                                    purchaseList,
                                    `[${index}].subtotal`,
                                    +Big(+e)
                                        .times(record.amount)
                                        .round(2),
                                )
                            }
                            if (record.subtotal && !record.amount) {
                                root = setObj(
                                    purchaseList,
                                    `[${index}].amount`,
                                    +Big(record.subtotal)
                                        .div(+e)
                                        .round(2),
                                )
                            }
                            setPurchaseList(deepClone(setObj(root, `[${index}].price`, e)))
                        }}
                    />
                    <PurchaseUnitPopover
                        unit={record.purchase_unit}
                        stockUnit={record.stock_unit}
                        unitRatio={record.purchase_unit_ratio}
                        positive={record.purchase_unit_positive}
                        onChange={e => {
                            const item = {
                                ...purchaseList[index],
                                purchase_unit: e.unit,
                                purchase_unit_ratio: e.unitRatio,
                                purchase_unit_positive: e.positive,
                            }
                            setPurchaseList(deepClone(setObj(purchaseList, [`${index}`], item)))
                        }}
                    >
                        <div data-cursor-pointer data-width-35 data-height-18 data-center data-position-relative>
                            <div className="unit-check"></div>元/{record.purchase_unit?.name}
                        </div>
                    </PurchaseUnitPopover>
                </Row>
            ),
        },
        {
            title: '采购数量',
            key: 'amount',
            width: 130,
            dataIndex: 'amount',
            render: (val, record, index) => {
                return (
                    <Row data-align-items-center>
                        <LayoutInput
                            value={val}
                            onBlur={e => {
                                let root = purchaseList
                                if (record.price) {
                                    root = setObj(
                                        purchaseList,
                                        `[${index}].subtotal`,
                                        +Big(+e)
                                            .times(record.price)
                                            .round(2),
                                    )
                                } else {
                                    root = setObj(
                                        purchaseList,
                                        `[${index}].price`,
                                        +Big(record.subtotal)
                                            .div(+e || 1)
                                            .round(2),
                                    )
                                }
                                setPurchaseList(deepClone(setObj(root, `[${index}].amount`, e)))
                            }}
                        />
                        {record.purchase_unit.name}
                    </Row>
                )
            },
        },
        {
            title: '小计',
            key: 'subtotal',
            dataIndex: 'subtotal',
            align: 'right',
            width: 130,
            render: (val, record, index) => {
                return (
                    <Row data-align-items-center>
                        <LayoutInput
                            value={val || 0}
                            valueRegExp={/^\d{0,6}(\.\d{0,3})?$/}
                            onBlur={e => {
                                let root = purchaseList
                                if (record.price && !record.amount) {
                                    root = setObj(
                                        purchaseList,
                                        `[${index}].amount`,
                                        +Big(+e)
                                            .div(record.price || 1)
                                            .round(2),
                                    )
                                }
                                if (record.amount) {
                                    root = setObj(
                                        purchaseList,
                                        `[${index}].price`,
                                        +Big(+e)
                                            .div(record.amount || 1)
                                            .round(2),
                                    )
                                }
                                setPurchaseList(deepClone(setObj(root, `[${index}].subtotal`, e)))
                            }}
                        />
                        元
                    </Row>
                )
            },
        },
        {
            title: '备注',
            key: 'remarks',
            dataIndex: 'remarks',
            align: 'right',
            render: (val, record, index) => (
                <RemarkPopover
                    value={val}
                    onConfirm={e => {
                        setPurchaseList(deepClone(setObj(purchaseList, `[${index}].remarks`, e)))
                    }}
                >
                    {val ? (
                        <div className={cls('remark')}>{val}</div>
                    ) : (
                        <Row data-justify-content-flex-end data-cursor-pointer data-align-items-center>
                            <div data-font-size-14 data-color-999>
                                请设置
                            </div>
                            <Iconfont data-margin-left-4 name="icon6youjiantou-20" size={16} />
                        </Row>
                    )}
                </RemarkPopover>
            ),
        },
        {
            title: '',
            key: 'reduce',
            width: 40,
            align: 'center',
            render: (val, record, index) => (
                <div data-cursor-pointer>
                    <Iconfont
                        name="icon6yichu-20"
                        size={20}
                        onClick={() => {
                            purchaseList.splice(index, 1)
                            setPurchaseList(deepClone(purchaseList))
                            reduceSelectGood(record.goods.id) // 同步商品库选中的id
                        }}
                    />
                </div>
            ),
        },
    ]

    const handleDay = useCallback((day: number) => {
        setDay(day)
        setEta(dayjs().add(day, 'day').format('YYYY-MM-DD'))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const removeOrder = useRequest(
        () =>
            $post({
                url: '/warehouse/deletepurchaseorder',
                params: {
                    order_id: props.orderId,
                },
            }),
        {
            manual: true,
            onSuccess: () => {
                $msg('success', '采购单已作废')
                layerManage.pop()
                purchaseOrderStore.setUpdateStatus()
            },
            onError: e => $msg('error', e.message),
        },
    )

    const handleRomoveOrder = usePersistFn(() => {
        showLayer(
            <Modal
                headerStyles={{ width: '440px' }}
                isShow
                type="danger"
                style={{ height: '156px' }}
                onClose={() => layerManage.pop()}
                onCancel={() => layerManage.pop()}
                onConfirm={() => {
                    layerManage.pop()
                    removeOrder.run()
                }}
            >
                <div>
                    <div data-font-size-20 data-font-weight-600 data-color-000>
                        确认作废该采购单吗？
                    </div>
                    <div data-font-size-14 data-color-999 data-margin-top-8>
                        作废后无法撤销
                    </div>
                </div>
            </Modal>,
        )
    })

    return (
        <BaseDrawer
            isShow
            title="编辑采购单"
            width={942}
            onClose={() => {
                layerManage.pop()
            }}
        >
            <Column data-height-100p>
                <Expaned data-overflow-auto>
                    <FormTitle hasLine={false} title="预计到货日期"></FormTitle>
                    <Row className={cls('date-container')}>
                        <div
                            className={cls('date-container', day === 0 ? 'item-active' : 'item')}
                            onClick={() => handleDay(0)}
                        >
                            今天
                            <div className="des" data-margin-left-8>
                                {formatDate(dayjs())}
                            </div>
                        </div>
                        <div
                            className={cls('date-container', day === 1 ? 'item-active' : 'item')}
                            onClick={() => handleDay(1)}
                        >
                            明天
                            <div className="des" data-margin-left-8>
                                {formatDate(dayjs().add(1, 'day'))}
                            </div>
                        </div>
                        <div
                            className={cls('date-container', day === 2 ? 'item-active' : 'item')}
                            onClick={() => handleDay(2)}
                        >
                            后天
                            <div className="des" data-margin-left-8>
                                {formatDate(dayjs().add(2, 'day'))}
                            </div>
                        </div>
                        <div className={classnames(cls('date-container', day === 3 ? 'item-active' : 'item'))}>
                            <DatePicker
                                bordered={false}
                                allowClear={false}
                                placeholder="选择日期"
                                value={day === 3 ? moment(eta.replace('-', '/'), 'YYYY/MM/DD') : void 0}
                                disabledDate={current => current <= dayjs().add(2, 'day')}
                                dateRender={current => (
                                    <div
                                        className="ant-picker-cell-inner"
                                        style={{
                                            borderRadius: '50%',
                                        }}
                                    >
                                        {current.date()}
                                    </div>
                                )}
                                onChange={(monent, dateString) => {
                                    setDay(3)
                                    setEta(dateString)
                                }}
                                suffixIcon={<i className="iconfont iconshijianshaixuan" />}
                            />
                        </div>
                    </Row>
                    <FormTitle hasLine={false} title="采购清单">
                        <div
                            data-font-size-16
                            data-margin-right-16
                            className="text-btn-blue"
                            onClick={() => {
                                showLayer(
                                    <SelectGoods
                                        confirmOnEnter
                                        onSubmit={async goods => {
                                            const existingGoodsIds = new Set(purchaseList.map(item => item.goods.id))
                                            const newGoods = goods.filter(good => !existingGoodsIds.has(good.id))
                                            let failedToLoad = false
                                            const formatGoods = await Promise.all(
                                                newGoods.map(async good => {
                                                    const item: IPurchaseList = {
                                                        goods: good,
                                                        amount: 0,
                                                        price: 0,
                                                        purchase_unit: good.stock_unit,
                                                        stock_unit: good.stock_unit,
                                                        purchase_unit_ratio: 1,
                                                        purchase_unit_positive: true,
                                                        remarks: '',
                                                        subtotal: 0,
                                                        supplier:
                                                            good.goods_default_supplier || goodsModel.defaultSupplier,
                                                    }

                                                    try {
                                                        const lastPurchase = await $post({
                                                            url: '/warehouse/getgoodslastpurchase',
                                                            params: { goods_id: good.id },
                                                        })
                                                        if (Number(lastPurchase.price) > 0) {
                                                            item.price = lastPurchase.price
                                                            item.purchase_unit = lastPurchase.purchase_unit
                                                            item.purchase_unit_ratio = lastPurchase.purchase_unit_ratio
                                                            item.purchase_unit_positive =
                                                                lastPurchase.purchase_unit_positive
                                                        }
                                                    } catch (error) {
                                                        failedToLoad = true
                                                    }

                                                    return item
                                                }),
                                            )

                                            setPurchaseList(current => uniqBy([...current, ...formatGoods], 'goods.id'))
                                            if (failedToLoad) {
                                                $msg('error', '部分商品上次采购价获取失败，请手动填写')
                                            }
                                        }}
                                    />,
                                )
                            }}
                        >
                            +添加商品
                        </div>
                    </FormTitle>
                    <div
                        style={{
                            height: '370px',
                        }}
                        className="table-container"
                    >
                        <Table
                            rowKey={record => record.goods.id}
                            loading={raftReq.loading || void 0}
                            bordered
                            pagination={false}
                            dataSource={purchaseList}
                            columns={columns}
                            scroll={{ y: 320 }}
                        ></Table>
                    </div>
                </Expaned>
                <div className={cls('bottom')}>
                    <Row
                        data-align-items-center
                        className="text-btn-blue"
                        onClick={() => {
                            showLayer(
                                <EditPruchaseConfirm
                                    confirm={false}
                                    list={purchaseList}
                                    eta={eta}
                                    orderId={props.orderId}
                                />,
                            )
                        }}
                    >
                        <i
                            data-margin-right-4
                            data-font-size-20
                            className="iconfont icon6cunweicaogao-20"
                            style={{
                                fontWeight: 500,
                            }}
                        />
                        存为草稿
                    </Row>
                    <Row>
                        {props.orderId && (
                            <Button
                                style={{
                                    marginRight: '30px',
                                }}
                                types="error"
                                onClick={handleRomoveOrder}
                            >
                                作废
                            </Button>
                        )}

                        <Button
                            disabled={btnDisabled}
                            types="default"
                            onClick={() => {
                                // handleSubmit(true)
                                showLayer(
                                    <EditPruchaseConfirm
                                        confirm
                                        list={purchaseList}
                                        eta={eta}
                                        orderId={props.orderId}
                                    />,
                                )
                            }}
                        >
                            确认{props.orderId ? '编辑' : '采购'}
                        </Button>
                    </Row>
                </div>
            </Column>
        </BaseDrawer>
    )
}

export default EditPurchase
